import React, { useRef, useEffect } from "react";
import { ListSummaryDimensionInput } from "../../style";
import Cell from "../Cell";
import { isMobileOnly } from "react-device-detect";

const DimensionCell = ({
  type,
  rowId,
  dimension,
  tempId,
  rawValue,
  placeholder,
  disabled,
  onFocus,
  onChange,
  onBlur,
  isFiller,
  isOverriden,
  errorMessage,
  sectionId,
  showClearOverrideTooltip,
  blurred,
  tableManager,
  inputId,
  invalid,
  hasError = false,
  inputStyle = null,
  pasteOverrides,
  handleTabNavigation,
  onContextMenu,
  viewMode,
  dimensionColorMap,
  onValueChange,
}) => {
  const inputRef = useRef();
  const containerRef = useRef();

  useEffect(() => {
    if (
      tableManager.isActive(type, rowId, dimension) &&
      inputRef.current &&
      typeof inputRef.current.setSelectionRange === "function"
    ) {
      const val = inputRef.current.value ?? "";
      inputRef.current.focus();
      inputRef.current.setSelectionRange(val.length, val.length);
    }
  }, [tableManager.isActive(type, rowId, dimension)]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (
        tableManager.getStatus(type, rowId, dimension) === "focus" &&
        e.key.length === 1 &&
        !e.metaKey &&
        !e.ctrlKey &&
        !e.altKey
      ) {
        e.preventDefault();
        tableManager.set(rowId, type, dimension, "active");
        setTimeout(() => {
          if (inputRef.current) {
            inputRef.current.focus();
            inputRef.current.value = "";
            const event = new Event("input", { bubbles: true });
            inputRef.current.dispatchEvent(event);
            inputRef.current.value = e.key;
            inputRef.current.setSelectionRange(1, 1);
            const syntheticEvent = {
              target: inputRef.current,
            };
            onChange(syntheticEvent);
          }
        }, 10);
      }
    };

    const currentRef = containerRef.current;
    if (currentRef) {
      currentRef.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      if (currentRef) {
        currentRef.removeEventListener("keydown", handleKeyDown);
      }
    };
  }, [tableManager.getStatus(type, rowId, dimension)]);

  useEffect(() => {
    if (viewMode === "review" && onValueChange && type === "module") {
      const value = pasteOverrides ?? placeholder ?? "";
      onValueChange(rowId, dimension, String(value));
    }
  }, [placeholder, pasteOverrides, viewMode, rowId, dimension, onValueChange]);

  const getBackgroundColor = () => {
    if (!dimensionColorMap || viewMode !== "review" || type !== "module")
      return undefined;
    const value = pasteOverrides ?? placeholder ?? "";
    const mapKey = `${dimension}__${value}`;

    return dimensionColorMap[mapKey] || undefined;
  };

  return (
    <Cell
      rowType={type}
      rowId={rowId}
      column={dimension}
      status="focus"
      inline={true}
      className="flex-grow-0 flex-shrink-0"
      customStyles={{
        width: isMobileOnly ? "10%" : "50px",
        backgroundColor: getBackgroundColor(),
      }}
      tableManager={tableManager}
      isTemp={tempId}
      errorMessage={errorMessage}
      isFillerRow={isFiller}
      sectionId={sectionId}
      showClearOverrideTooltip={showClearOverrideTooltip}
      blurred={blurred}
      hasError={hasError}
      onContextMenu={onContextMenu}
    >
      {isFiller ||
      tableManager.isFocused(type, rowId, dimension) ||
      tableManager.getStatus(type, rowId, dimension) == "idle" ? (
        <div
          ref={containerRef}
          className={`w-100 text-center p-1 dimension ${
            isOverriden || type === "section" || viewMode === "review"
              ? "overriden-focus-text"
              : "placeholder-grey-text"
          }${pasteOverrides ? "overriden-focus-text" : ""}`}
          id={inputId}
          style={inputStyle}
          tabIndex={0}
        >
          {pasteOverrides ?? placeholder}
        </div>
      ) : (
        <ListSummaryDimensionInput
          innerRef={inputRef}
          id={inputId}
          type="text"
          value={rawValue}
          disabled={disabled}
          placeholder={placeholder}
          onFocus={onFocus}
          onChange={onChange}
          onBlur={onBlur}
          className={`dimension ${isOverriden ? "overriden-text-input" : ""} ${
            rawValue === "" ? "placeholder-grey" : ""
          }`}
          autoComplete="off"
          invalid={invalid}
          style={inputStyle}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.target.blur();
              setTimeout(() => {
                if (tableManager.isActive(type, rowId, dimension)) {
                  tableManager.set(rowId, type, dimension, "focus");
                }
              }, 50);
            }
            if (e.key === "Tab") {
              e.preventDefault();
              e.target.blur();
              handleTabNavigation();
            }
          }}
          autoFocus={tableManager.isActive(type, rowId, dimension)}
        />
      )}
    </Cell>
  );
};

export default DimensionCell;
